import * as common from 'settings/common';
import * as wui from 'settings/wui';
import * as group from 'settings/group';
import * as feed from 'settings/feed';

export default {
  ...common.styles,
  ...wui.styles,
  ...feed.styles,
  ...group.styles,
};
